"use strict";exports.hmsToMs=function(r){var e=r.split("."),t=e[0],u=e[1],n=Number(null!=u?u:0);return t.split(":").map((function(r){return Number(r)||0})).reverse().reduce((function(r,e,t){return r+1e3*e*Math.pow(60,t)}),0)+n};
//# sourceMappingURL=hmsToMs.cjs.map
